import TwitterIcon from '@material-ui/icons/Twitter'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import FacebookIcon from '@material-ui/icons/Facebook'
import LinkIcon from '@material-ui/icons/Link'
import MusicNoteIcon from '@material-ui/icons/MusicNote'
import { Link, Box, Container, Grid, Typography } from '@material-ui/core'
import css from '../AuthorProfile.styles.scss'
import classNames from 'classnames'

const SocialLinks = ({ author }) => {
  if (
    author.twitterUrl ||
    author.linkedinUrl ||
    author.facebookUrl ||
    author.tiktokUrl ||
    author.websiteUrl
  ) {
    return (
      <Grid id="social" className={classNames(css.authorProfileSocial)}>
        {author.twitterUrl && (
          <Link href={author.twitterUrl}>
            <TwitterIcon className={classNames(css.socialIcon)} />
          </Link>
        )}
        {author.linkedinUrl && (
          <Link href={author.linkedinUrl}>
            <LinkedInIcon className={classNames(css.socialIcon)} />
          </Link>
        )}
        {author.facebookUrl && (
          <Link href={author.facebookUrl}>
            <FacebookIcon className={classNames(css.socialIcon)} />
          </Link>
        )}
        {author.tiktokUrl && (
          <Link href={author.tiktokUrl}>
            <MusicNoteIcon className={classNames(css.socialIcon)} />
          </Link>
        )}
        {author.websiteUrl && (
          <Link href={author.websiteUrl}>
            <LinkIcon className={classNames(css.socialIcon)} />
          </Link>
        )}
      </Grid>
    )
  } else {
    return null
  }
}

export default SocialLinks
